import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openBuyCheckout } from 'reactApp/modules/payment/payment.module';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { Product } from 'reactApp/types/Billing';

type UseTariffBuyProps = {
    paySource: string;
};

export const useTariffBuy = ({ paySource }: UseTariffBuyProps) => {
    const dispatch = useDispatch();

    return useCallback(
        (product: Product) => {
            dispatch(
                openBuyCheckout({
                    productId: product.id,
                    paySource,
                    hideOtherTariffs: true,
                    hideSwitchSidebarBlock: true,
                    title: 'Все возможности Mail с\u00A0подпиской Mail Space',
                    onSuccess() {
                        closePopupHelper(popupNames.BUY_DISABLE_ADS);
                    },
                })
            );
        },
        [dispatch, paySource]
    );
};
